<div class="card p-0 announcement-card">
  <div>
    @if (!announcements || announcements.length === 0) {
      <div class="p-3 text-center fw-bold">
        <span class="announcements-empty-message">Hier können Sie die Ankündigungen sehen, die in naher Zukunft veröffentlicht werden</span>
      </div>
    }
    @if (announcements && announcements.length > 0) {
      <carousel
        [pauseOnFocus]="true"
        [isAnimated]="true"
        class="announcements"
        >
        @for (announcement of announcements; track announcement) {
          <slide data-tooltip-no-anchor>
            @if (announcement.image) {
              <div class="float-start mobile-size-100">
                <img [src]="announcement.image | blobUrl: containerName" />
              </div>
            }
            <div class="float-start detail-size">
              <h5><span class="announcement-title">{{ announcement.title }}</span></h5>
              <div class="content-height">
                <div
                  class="position-relative description announcement-description"
                  [innerHTML]="announcement.description | safeHtml"
                ></div>
                <a
                  [href]="announcement.moreDetails"
                  target="_blank"
                  class="btn btn-primary d-inline-flex align-items-center justify-content-center announcement-details-link button-link"
                  >
                  <span class="announcement-details-text">Mehr Details</span>
                </a>
              </div>
            </div>
          </slide>
        }
      </carousel>
    }
  </div>
</div>
